function splitFiles(files) {
  const media = [];
  const newMedia = [];
  files.forEach((file) => {
    if (file.file) {
      newMedia.push(file);
    } else {
      media.push(file);
    }
  });
  return [media, newMedia];
}

export default splitFiles;
